/**
 * Created by jinm on 2018. 9. 20..
 */
import React, { Component}  from 'react';
import $ from 'jquery';
import SweetAlert from 'sweetalert-react';
import { Redirect  } from 'react-router-dom';

export default class ProductBased extends Component {
    constructor(props) {
        super(props);

        this.state={
            step1: '',
            step2: '',
            step3: '',
            keywords: [],
            searchValidationAlert:false,
            redirect : false,
        };

        this.keywords = require('./productBased.json');
    }

    handleKeyword(step, keyword){
        let updateState = this.state;
        switch(step) {
            case 4:
                let updateKeyword = this.state.keywords;
                let index = updateKeyword.indexOf(keyword);
                if(index === -1)
                    updateKeyword.push(keyword);
                else
                    updateKeyword.splice(index, 1);

                updateState = {
                    keywords: updateKeyword
                };
                break;
            case 1:
                updateState = {
                    step1: keyword,
                    step2: '',
                    step3: '',
                };
                break;
            case 2:
                updateState = {
                    step2: keyword,
                    step3: ''
                };
                break;
            case 3:
                updateState = {
                    step3: keyword
                };
                break;
        }
        this.setState(updateState);
    }

    removeKeywordHandle(keyword){
        let updateKeyword = this.state.keywords;
        let index = updateKeyword.indexOf(keyword);
        updateKeyword.splice(index, 1);
        let updateState = {
            keywords: updateKeyword
        };
        this.setState(updateState);
    }

    allDel() {
        this.setState({keywords:[]});
    }

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect  to={{ pathname: '/result', query: this.state.productListProps }} />;
        }
    }

    productSearch() {
        // console.log(this.state.keywords);
        if(this.state.keywords.length===0) {
            this.setState({
                searchValidationAlert: true
            })
        } else {
            let props = {
                "query" : "",
                "scenario_code" : "PRD",
                "input_component": {
                    "function":[],
                    "component filter":[],
                    "product_name": this.state.keywords,
                    "filter_common": {
                        "domain": ["Protozoa", "bacteria", "Archaea", "Plantae", "Animalia", "Fungi", "Chromista"],
                        "format_date": 2,
                        "format":1,
                        "usage_rights":2,
                        "language":1
                    },
                }
            }

            this.setState({productListProps:props});
            // console.log('props!!',props)

            this.setState({
                redirect: true
            })

        }

    }

    render() {

        let listTab = [];
        listTab.push(<ListTabObject key="step1" step={1} title="step 1" activeKeyword={this.state.step1} keywords={this.keywords} handleKeyword={(step, keyword) => this.handleKeyword(step, keyword)}/>);
        for(let step1 in this.keywords){
            if(this.state.step1 === step1)
                listTab.push(<ListTabObject key={step1} step={2} title="step 2" activeKeyword={this.state.step2} parent={step1} keywords={this.keywords[step1]} handleKeyword={(step, keyword) => this.handleKeyword(step, keyword)}/>);
            for(let step2 in this.keywords[step1]){
                if(this.state.step2 === step2)
                    listTab.push(<ListTabObject key={step2} step={3} title="step 3" activeKeyword={this.state.step3} parent={step2} keywords={this.keywords[step1][step2]} handleKeyword={(step, keyword) => this.handleKeyword(step, keyword)}/>);
                for(let step3 in this.keywords[step1][step2]){
                    if(this.state.step3 === step3)
                        listTab.push(<ListTabArray key={step3} step={4} title="step 4" activeKeywords={this.state.keywords} parent={step3} keywords={this.keywords[step1][step2][step3]} handleKeyword={(step, keyword) => this.handleKeyword(step, keyword)}/>);
                }
            }
        }

        let keywords = this.state.keywords.map(v => {
            return (
                <li key={v}>
                    {v}
                    <button onClick={() => this.removeKeywordHandle(v)}>×</button>
                </li>
            )
        });

        return (
            <div id="productBased">
                {this.renderRedirect()}
                <SweetAlert
                    show={this.state.searchValidationAlert}
                    title="Not able to search"
                    text="You must fill in one search bar at least."
                    onConfirm={() => {this.setState({ searchValidationAlert: false })}}
                />
                <div className="productBasedInput wrap">
                    <ul>
                        {keywords}
                        <span onClick={this.allDel.bind(this)}>×</span>
                    </ul>
                    <button onClick={this.productSearch.bind(this)}>Search</button>
                </div>
                <div className="scenarioBox productStep">
                    {listTab}
                </div>
            </div>
        );
    }
}


class ListTabObject extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        // console.log($('.productStep').children());
        if($('.productStep').children().length===1) {
            $('.productStep').css('background','#f7f7f7');
        } else if($('.productStep').children().length===2) {
            $('.productStep .eachStep').css('width','25%');
            $('.productStep .eachStep:last-child').css('width','75%');
            $('.productStep').css('background','#ededed');
        } else if($('.productStep').children().length===3) {
            $('.productStep .eachStep').css('width','25%');
            $('.productStep .eachStep:last-child').css('width','50%');
            $('.productStep').css('background','#e6e6e6');
        } else if($('.productStep').children().length===4) {
            $('.productStep .eachStep').css('width','25%');
            $('.productStep .eachStep:last-child').css('width','25%');
        }
    }

    handleKeyword(activeKeyword) {
        this.props.handleKeyword(this.props.step, activeKeyword);
    }


    getKeywordDom(){
        let stepHtml = [];
        for(let row in this.props.keywords) {
            let liStyle = {};
            if(this.props.activeKeyword === row && this.props.title === 'step 1') {
                liStyle = {background: "#F7F7F7"};
            } else if(this.props.activeKeyword === row && this.props.title === 'step 2') {
                liStyle = {background: "#EDEDED"};
            } else if(this.props.activeKeyword === row && this.props.title === 'step 3') {
                liStyle = {background: "#E6E6E6"};
            }
            stepHtml.push(<li key={row}
                              onClick={() => this.handleKeyword(row)}
                              style={liStyle}
            >
                {row}
            </li>);
        }

        return (
            <ul>
                {stepHtml}
            </ul>
        );
    }


    render() {
        return (
            <div className="eachStep">
                <h4>{this.props.title}</h4>
                {this.getKeywordDom()}
            </div>
        );
    }
}

class ListTabArray extends ListTabObject {
    constructor(props) {
        super(props);

    }

    getKeywordDom(){
        let stepHtml = [];
        this.props.keywords.map(row => {
            let liStyle = {};
            if(this.props.activeKeywords.indexOf(row) > -1)
                liStyle = {
                    // background: "#ee4b55"
                };
            stepHtml.push(<li key={row}
                              onClick={() => this.handleKeyword(row)}
                              style={liStyle}
            >
                {row}
            </li>);
        });

        return (
            <ul>
                {stepHtml}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProductBased.js